/* Stickidy davranış mesajları (30 Eyl 2026, v48) — mevcut şeritlere GÖMÜLÜ (ayrı bar yok; sahip kararı).
   Nerede: koleksiyonda lime "Düzenle" şeridi görünürse alt satırı (özet) kısa süre pembe mesaj hapına döner; değilse sayfa üstündeki
   "3 AL 2 ÖDE" slogan kutusu kısa süre PEMBEYE döner, mesaj beyaz yazıyla görünür, sonra beyaz slogan geri gelir (sahip onayı 30 Eyl).
   Mesajlar (öncelik sırası): 🛒 sepet bekliyor (yeni oturum + son ziyaretten ≥30 dk) · 🎁 3 Al 2 Öde (N ürün daha, en ucuzu bedava) ·
   🎨 yarım stüdyo tasarımı (7 gün) · 🔁 sepetteki kaplamanın başka cihaz versiyonu.
   Kurallar: ilk ziyaretin ilk sayfasında yok · sayfa başına 1, oturum başına 2 · her tür oturumda bir kez · 7 günde 3 kez tıklanmadan
   gösterilen tür 3 gün susar · çekmece/menü açıkken ya da yazı yazılırken beklenir · hareket azaltmada animasyon yok.
   Test: ?stk_nudge=sepet|bx|taslak|capraz kuralları atlayıp o mesajı gösterir. Veriler yalnız bu tarayıcıda (localStorage/sessionStorage). */
(function () {
  'use strict';
  if (window.__stkNudge) return;
  window.__stkNudge = true;
  var el = document.getElementById('stk-nudge-data'); if (!el) return;
  var D; try { D = JSON.parse(el.textContent); } catch (e) { return; }
  var RM = matchMedia('(prefers-reduced-motion: reduce)');
  var LK = 'stkNudge.v1', SK = 'stkNudgeS.v1', DAY = 864e5, now = Date.now();
  var FAM = { iphone: 'iPhone', samsung: 'Samsung', ipad: 'iPad', macbook: 'MacBook' };
  var ARW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  function get(st, k, d) { try { return JSON.parse(st.getItem(k) || 'null') || d; } catch (e) { return d; } }
  function put(st, k, v) { try { st.setItem(k, JSON.stringify(v)); } catch (e) { /* gizli sekme */ } }
  var L = get(localStorage, LK, {}), S = get(sessionStorage, SK, null), fresh = !S;
  if (!S) S = { t: now, pv: 0, shown: [] };
  S.pv++;
  var firstEver = !L.first, last = L.last || 0;
  if (!L.first) L.first = now;
  L.last = now; L.mute = L.mute || {}; L.cnt = L.cnt || {}; L.du = L.du || {};
  /* stüdyo sayfasında: bu sayfanın taslak anahtarı → adres (taslak mesajı buraya döner) */
  var studio = document.querySelector('[data-stk-studio]');
  if (studio) { var lc = studio.getAttribute('data-lock-category') || '', cs = studio.getAttribute('data-case') || ''; L.du['stkStudioDraft.v1' + (lc ? ':' + lc + (cs ? ':kilif' : '') : '')] = location.pathname; }
  put(localStorage, LK, L); put(sessionStorage, SK, S);

  var force = (location.search.match(/[?&]stk_nudge=(\w+)/) || [])[1];
  if (!force) {
    if (firstEver && S.pv === 1) return;
    if (S.shown.length >= 2) return;
  }

  /* ── adaylar ── */
  var C = [];
  if ((D.n > 0 && fresh && last && now - last > 30 * 60 * 1000) || force === 'sepet')
    C.push({ k: 'sepet', e: '🛒', h: '<b>Sepetinde ' + (D.n || 2) + ' ürün</b> seni bekliyor', a: 'Sepeti aç', go: 'cart' });
  if ((D.bx > 0 && D.bx % 3) || force === 'bx') {
    var need = D.bx % 3 ? 3 - D.bx % 3 : 1;
    C.push({ k: 'bx', e: '🎁', h: '<b>' + (need === 1 ? 'Bir ürün daha' : need + ' ürün daha') + '</b> ekle, en ucuzu bedava', hs: '<b>+' + need + ' ürün</b>, en ucuzu bedava', a: 'Sepeti aç', go: 'cart' });
  }
  if (!D.studio || force === 'taslak') {
    var dr = null;
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i); if (!k || k.indexOf('stkStudioDraft.v1') !== 0) continue;
        var v = JSON.parse(localStorage.getItem(k) || 'null');
        if (!v || !v.layers || !v.layers.length || !v.t || now - v.t > 7 * DAY) continue;
        var url = L.du[k] || (k === 'stkStudioDraft.v1' ? '/pages/sticker-studio' : '');
        if (url && url !== location.pathname && (!dr || v.t > dr.t)) dr = { t: v.t, url: url };
      }
    } catch (e) { dr = null; }
    if (dr || force === 'taslak') C.push({ k: 'taslak', e: '🎨', h: '<b>Tasarımın kaydedildi</b>, kaldığın yerden devam et', hs: '<b>Tasarımın</b> kaydedildi', a: 'Devam et', go: dr ? dr.url : '/pages/sticker-studio' });
  }
  C = C.filter(function (c) { return force ? c.k === force : S.shown.indexOf(c.k) < 0 && !(L.mute[c.k] > now); });

  function cross(cb) {
    if ((force && force !== 'capraz') || (!force && (S.shown.indexOf('capraz') > -1 || L.mute.capraz > now))) return cb(null);
    var mine = {}; try { mine = JSON.parse(localStorage.getItem('stkModel.v1') || '{}') || {}; } catch (e) { mine = {}; }
    var hs = {}; (D.hs || []).forEach(function (h) { hs[h] = 1; });
    var tries = [];
    (D.kap || []).forEach(function (it) {
      var m = /^(.*)-(iphone|samsung|ipad|macbook)$/.exec(it.h || ''); if (!m) return;
      var fams = Object.keys(FAM).filter(function (f) { return f !== m[2] && !hs[m[1] + '-' + f]; });
      fams.sort(function (a, b) { return (mine[b] ? 1 : 0) - (mine[a] ? 1 : 0); });
      fams.forEach(function (f) { tries.push({ h: m[1] + '-' + f, f: f, t: String(it.t || '').split(' - ')[0] }); });
    });
    tries = tries.slice(0, 3);
    (function next(i) {
      if (i >= tries.length) return cb(force === 'capraz' ? { k: 'capraz', e: '🔁', h: '<b>Glacis</b> MacBook için de var', hs: '<b>Glacis</b> MacBook için de var', a: 'Göster', go: '/products/glacis-macbook' } : null);
      var t = tries[i];
      fetch('/products/' + t.h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p && p.available) cb({ k: 'capraz', e: '🔁', h: '<b>' + esc(t.t) + '</b> ' + FAM[t.f] + ' için de var', hs: '<b>' + esc(t.t) + '</b> ' + FAM[t.f] + ' için de var', a: 'Göster', go: '/products/' + t.h });
        else next(i + 1);
      }).catch(function () { next(i + 1); });
    })(0);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ── gösterim ── */
  var css = '.stk-nd-pill{display:inline-flex;align-items:center;gap:6px;max-width:100%;border-radius:99px;background:#D834A2;color:#fff!important;text-decoration:none!important;font-family:Jost,"Helvetica Neue",Arial,sans-serif;font-weight:500;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer}' +
    '.stk-nd-pill b{font-weight:700}.stk-nd-pill .e{flex:none;font-size:1.15em;line-height:1}.stk-nd-pill svg{flex:none;width:.95em;height:.95em;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}' +
    '.stk-nd-pill span{overflow:hidden;text-overflow:ellipsis}' +
    '.stk-cg__bar-tx .stk-nd-pill{align-self:flex-start;margin-top:2px;padding:4px 10px 4px 8px;font-size:13.5px}' +
    '.stk-nd-tile{transition:background-color .35s cubic-bezier(.23,1,.32,1)}' +
    '.stk-nd-tile.stk-nd-pink{background-color:#D834A2!important}' +
    '.stk-nd-ann{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;width:100%;min-height:100%;text-align:center;color:#fff}' +
    '.stk-nd-msg{display:inline-flex;align-items:center;gap:8px;max-width:100%;color:#fff!important;font:500 17px/1.25 Jost,"Helvetica Neue",Arial,sans-serif;white-space:nowrap}' +
    '.stk-nd-msg b{font-weight:700}.stk-nd-msg .e{flex:none;font-size:1.2em;line-height:1}.stk-nd-msg span{overflow:hidden;text-overflow:ellipsis}.stk-nd-msg svg{flex:none;width:17px;height:17px;fill:none;stroke:#fff;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}' +
    '.stk-nd-ann small{font:500 13px/1.2 Jost,sans-serif;color:rgba(255,255,255,.88)}' +
    '@media (min-width:990px){.stk-nd-ann{flex-direction:row;gap:14px}.stk-nd-msg{font-size:17px}.stk-nd-ann small{font-size:14px;text-decoration:underline;text-underline-offset:3px}}';
  function addCss() { if (document.getElementById('stk-nd-css')) return; var s = document.createElement('style'); s.id = 'stk-nd-css'; s.textContent = css; document.head.appendChild(s); }
  function anim(elm, kf, ms) { if (RM.matches || !elm.animate) return { finished: Promise.resolve() }; return elm.animate(kf, { duration: ms, easing: 'cubic-bezier(.23,1,.32,1)', fill: 'both' }); }
  function busy() {
    var cd = document.querySelector('cart-drawer'); if (cd && cd.classList.contains('active')) return true;
    var a = document.activeElement; if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    if (document.body.classList.contains('overflow-hidden')) return true;
    return document.hidden;
  }
  function act(c, e) {
    L.cnt[c.k] = []; put(localStorage, LK, L);
    if (c.go === 'cart') { var cd = document.querySelector('cart-drawer'); if (cd && cd.open) { if (e) e.preventDefault(); cd.open(); return; } location.href = '/cart'; return; }
    location.href = c.go;
  }
  function record(c) {
    S.shown.push(c.k); put(sessionStorage, SK, S);
    var arr = (L.cnt[c.k] || []).filter(function (t) { return now - t < 7 * DAY; }); arr.push(now); L.cnt[c.k] = arr;
    if (arr.length >= 3) { L.mute[c.k] = now + 3 * DAY; L.cnt[c.k] = []; }
    put(localStorage, LK, L);
  }
  function pillHTML(c, short) { return '<span class="e" aria-hidden="true">' + c.e + '</span><span>' + (short && c.hs ? c.hs : c.h) + '</span>' + ARW; }

  function inBar(c, bar) {
    var tx = bar.querySelector('.stk-cg__bar-tx'), sm = tx && tx.querySelector('small'); if (!tx || !sm) return false;
    addCss(); record(c);
    var p = document.createElement('a'); p.className = 'stk-nd-pill'; p.href = c.go === 'cart' ? '/cart' : c.go; p.setAttribute('role', 'status'); p.lang = 'tr';
    p.innerHTML = pillHTML(c, true); p.addEventListener('click', function (e) { act(c, e); });
    sm.style.display = 'none'; tx.appendChild(p);
    anim(p, [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], 320);
    setTimeout(function () {
      anim(p, [{ opacity: 1 }, { opacity: 0, transform: 'translateY(-6px)' }], 200).finished.then(function () { p.remove(); sm.style.display = ''; anim(sm, [{ opacity: 0 }, { opacity: 1 }], 240); });
    }, 6500);
    return true;
  }
  function inAnn(c, box) {
    var link = box.querySelector('a.announcement-bar') || box.querySelector('a'), item = box.querySelector('.announcement-bar__item'); if (!item) return false;
    addCss(); record(c);
    var old = item.innerHTML, oldHref = link && link.getAttribute('href');
    var wrap = document.createElement('div'); wrap.className = 'stk-nd-ann'; wrap.lang = 'tr'; wrap.setAttribute('role', 'status');
    wrap.innerHTML = '<span class="stk-nd-msg">' + pillHTML(c, innerWidth < 600) + '</span><small>' + c.a + ' ›</small>';
    var tile = box.querySelector('.content-item-container') || box; tile.classList.add('stk-nd-tile');
    if (innerWidth < 990) { var hh = item.getBoundingClientRect().height; item.style.height = hh + 'px'; item.style.overflow = 'hidden'; }   /* telefonda kutu yüksekliği sabit: başlık kaymasın (masaüstünde satırı logo/arama belirler) */
    var onClick = function (e) { act(c, e); };
    anim(item, [{ opacity: 1 }, { opacity: 0, transform: 'translateY(-8px)' }], 180).finished.then(function () {
      item.innerHTML = ''; item.appendChild(wrap); tile.classList.add('stk-nd-pink');
      if (link) { link.setAttribute('href', c.go === 'cart' ? '/cart' : c.go); link.addEventListener('click', onClick); }
      anim(item, [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], 340);
      setTimeout(function () {
        anim(item, [{ opacity: 1 }, { opacity: 0, transform: 'translateY(-8px)' }], 200).finished.then(function () {
          tile.classList.remove('stk-nd-pink'); item.innerHTML = old; item.style.height = ''; item.style.overflow = ''; if (link) { link.removeEventListener('click', onClick); if (oldHref != null) link.setAttribute('href', oldHref); }
          anim(item, [{ opacity: 0 }, { opacity: 1, transform: 'none' }], 260);
        });
      }, 7000);
    });
    return true;
  }
  function visible(elm) { if (!elm) return false; var r = elm.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && r.width > 0; }
  function place(c) {
    var t0 = Date.now();
    (function tryIt() {
      if (Date.now() - t0 > 30000) return;
      if (busy()) return setTimeout(tryIt, 1000);
      var bar = document.querySelector('.stk-cg__bar');
      if (bar && !bar.hidden && inBar(c, bar)) return;
      var ann = document.querySelector('.header__announcement-bar');
      if (ann && visible(ann) && inAnn(c, ann)) return;
      setTimeout(tryIt, 700);
    })();
  }
  /* yalnız ?stk_nudge= ile: mesajı elle yeniden göster (sahip/test önizlemesi) */
  if (force) window.stkNudgeShow = function () { if (C[0]) place(C[0]); else cross(function (x) { if (x) place(x); }); return true; };
  function start() {
    var c = C[0];
    if (c) return setTimeout(function () { place(c); }, force ? 1200 : 2500);
    cross(function (x) { if (x && (force || !(L.mute.capraz > now))) setTimeout(function () { place(x); }, force ? 600 : 1800); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
